const SUCCESS_MESSAGES = {
  25: [
    "¡Bien! Has ganado 25 puntos",
    "¡Correcto! +25 puntos",
    "¡Sigue así! 25 puntos para ti",
    "¡Genial! Has sumado 25 puntos",
  ],
  50: [
    "¡Muy bien! Has ganado 50 puntos",
    "¡Correcto! +50 puntos",
    "¡Estupendo! 50 puntos para ti",
    "¡Genial! Has sumado 50 puntos",
  ],
  100: [
    "¡Excelente! ¡Has ganado 100 puntos!",
    "¡Increíble! ¡100 puntos más!",
    "¡Fantástico! ¡+100 puntos!",
    "¡Muy bien! ¡100 puntos para ti!",
    "¡Impresionante! ¡Has conseguido 100 puntos!",
  ],
  200: [
    "¡WOW! ¡¡¡200 PUNTOS!!!",
    "¡INCREÍBLE! ¡¡¡Has ganado 200 puntos!!!",
    "¡ESPECTACULAR! ¡¡¡200 PUNTOS!!!",
    "¡ASOMBROSO! ¡¡¡+200 puntos!!!",
    "¡BRUTAL! ¡¡¡Has conseguido 200 puntos!!!",
    "¡FENOMENAL! ¡¡¡200 PUNTOS PARA TI!!!",
  ],
};

const INCORRECT_MESSAGE = "¡Vuélvelo a intentar!";

module.exports = { SUCCESS_MESSAGES, INCORRECT_MESSAGE };
